module.exports = __webpack_public_path__ + "img/img-subir-menu.8ba904a4.webp";